import { render, staticRenderFns } from "./TIcon.vue?vue&type=template&id=625a5de7"
import script from "./TIcon.vue?vue&type=script&lang=js"
export * from "./TIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports